import React from "react";
import { galleryImages, studioInfo } from "../../mock";
import SectionLabel from "./SectionLabel";
import Reveal from "./Reveal";

const Studio = () => {
  return (
    <section id="studio" className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-32">
      <SectionLabel>Lo studio</SectionLabel>

      <div className="flex flex-wrap items-end justify-between gap-6 mt-8">
        <h2 className="font-display text-4xl md:text-7xl text-white">
          Dentro{" "}
          <span style={{ fontStyle: "italic", fontWeight: 800 }} className="text-white/45">
            ONEVO.
          </span>
        </h2>
        <span className="font-mono-label text-[11px] text-white/45">
          Via Pastrengo 15 · Torino
        </span>
      </div>

      <div className="grid md:grid-cols-2 gap-4 md:gap-6 mt-12">
        {galleryImages.map((img, i) => (
          <Reveal key={img.src} delay={i * 90}>
            <div className="img-zoom rounded-sm">
              <img
                src={img.src}
                alt={img.alt}
                className="w-full h-[300px] md:h-[440px] object-cover rounded-sm"
              />
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};

export default Studio;
